import { Linked } from "@type-r/models";
import { useLinked } from "@type-r/react";
import { Columns, TilesList } from "lqx-react";
import React from "react";
import { ImportJob } from "../api/importJob";
import { DetailsPaneColumn, TilesListColumn } from "../components/item-card-styles";
import { ImportJobDetailsPane } from "./import-job-details-pane";
import { ImportJobsCardRenderer } from "./import-jobs-card";

export const ImportJobsList = ({
    importJobCards,
    $doProcessJob,
    scrollPagination
}
    : {
        importJobCards: ImportJob[],
        $doProcessJob: Linked<{ jobId?: Number, needApproval?: boolean, actionType: String, assetTypeId: Number }>,
        scrollPagination: (e) => void
    }) => {
    const $activeCard = useLinked<ImportJob>(null);

    return (
        <>
            <Columns style={{ height: 'calc(100% - 80px)' }} onScroll={scrollPagination}>
                <TilesListColumn>
                    <TilesList
                        items={importJobCards}
                        itemSize={100}
                        renderer={ImportJobsCardRenderer($doProcessJob, $activeCard)}
                    />
                </TilesListColumn>
                {$activeCard.value &&
                    <DetailsPaneColumn>
                        <ImportJobDetailsPane $activeCard={$activeCard} $doProcessJob={$doProcessJob} importJobCards={importJobCards} />
                    </DetailsPaneColumn>}
            </Columns>
        </>
    );
};